import moment from "moment";
import { Pagination } from "../../components/pagination/Pagination";
import Table from "../../components/Table/Table";
import usePurchaseStock from "./hook/usePurchaseStock";
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';

const PurchaseOrder = () => {
  const { data, methods } = usePurchaseStock();

  const { purchaseStockList, controller, totalCount } = data;
  const { handlePagination, purchaseStatusChange } = methods;

  const TableHead = [
    { label: "#", id: "" },
    // { label: "Product Name", id: "name" },
    { label: "Created by ", id: "category" },
    { label: "Date", id: "date" },
    { label: "Stock Quantity", id: "stockQuantity" },
    { label: "MRP", id: "mrp" },
    { label: "Purchase Price", id: "purchasePrice" },
    { label: "Status", id: "status" },
    { label: "Action", id: "action" },
  ];

  return (
    <div>
      <div className="mt-2">
        <table className="table">
          <Table TableHeadData={TableHead} rowCount={TableHead?.length} />
          <tbody>
            {purchaseStockList?.map((item, index) => {
              return (
                <tr
                  className="text-start rounded-row "
                  style={{
                    borderRadius: "50px",
                    backgroundColor: "#fff",
                  }}
                >
                  <td className="table-link">
                    {controller.rowsPerPage * (controller.page - 1) + index + 1}{" "}
                  </td>
                  {/* <td className="table-link">
                    {item?.inventory_id?.productName}
                  </td> */}
                  <td className="">{item?.createdby_id?.firstName}</td>
                  <td>{moment(item?.purchaseDate).format("YYYY-MM-DD")}</td>
                  <td className="">{item?.quantity}</td>
                  <td className="">{item?.price}</td>
                  <td className="">{item?.purchasePrice}</td>
                  <td className="">{item?.statusType}</td>
                  {console.log(item?.status)  }
                  <td>
                     <div className="dropdown p-0 align-items-center justify-content-center">
                      <i
                        className="fas fa-ellipsis-v pointer p-2"
                        id="dropdownMenuLink"
                        data-bs-toggle={item?.status === 'PENDING' && item?.isStatusChange === false ? 'dropdown' : ''}
                        aria-expanded="false"
                        style={{cursor: item?.status === 'PENDING' && item?.isStatusChange === false ? 'pointer' :'not-allowed'}}
                      />
                      <ul
                        className="dropdown-menu"
                        aria-labelledby={`dropdown-${item._id}`}
                      >
                         <li
                          className="dropdown-item"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            purchaseStatusChange(item._id, "APPROVED")
                          }
                        >
                          Confirm
                        </li> 
                      <li
                          className="dropdown-item"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            purchaseStatusChange(item._id, "REJECTED")
                          }
                        >
                          Discard
                        </li>              
                      </ul>
                    </div>
                  </td>
                </tr>
              );
            })}

            <td colSpan={"20"}>
              {totalCount > 10 && (
                <Pagination
                  style={{ backgroundColor: "#fff" }}
                  count={totalCount}
                  controller={controller}
                  setController={handlePagination}
                />
              )}
            </td>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PurchaseOrder;
